const buildColumnTransforms = (visibleColumns) => ({
  type: 'spreadsheet',
  subtype: 'showColumns',
  params: visibleColumns
});

export default buildColumnTransforms;
